var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMood(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M31.134,32.053c-8.793,0-15.947,7.154-15.947,15.947c0,8.793,7.154,15.947,15.947,15.947S47.082,56.793,47.082,48 C47.082,39.207,39.927,32.053,31.134,32.053z M31.134,59.947c-6.588,0-11.947-5.359-11.947-11.947s5.359-11.947,11.947-11.947 S43.082,41.412,43.082,48S37.722,59.947,31.134,59.947z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.748,51.925c-1.232,1.232-2.871,1.912-4.614,1.912c-1.743,0-3.381-0.68-4.614-1.912c-0.781-0.781-2.047-0.781-2.829,0 c-0.781,0.78-0.781,2.047,0,2.828c1.988,1.988,4.632,3.084,7.443,3.084c2.812,0,5.455-1.096,7.443-3.084 c0.781-0.781,0.781-2.048,0-2.828C37.795,51.144,36.529,51.144,35.748,51.925z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.866,32.053c-8.793,0-15.947,7.154-15.947,15.947c0,8.793,7.154,15.947,15.947,15.947S80.813,56.793,80.813,48 C80.813,39.207,73.659,32.053,64.866,32.053z M64.866,59.947c-6.588,0-11.947-5.359-11.947-11.947s5.359-11.947,11.947-11.947 S76.813,41.412,76.813,48S71.454,59.947,64.866,59.947z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.866,49.44c-2.812,0-5.455,1.096-7.442,3.084c-0.781,0.781-0.781,2.048,0,2.828c0.781,0.781,2.047,0.781,2.828,0 c1.232-1.232,2.871-1.912,4.614-1.912s3.382,0.68,4.614,1.912c0.391,0.391,0.902,0.586,1.414,0.586s1.023-0.195,1.414-0.586 c0.781-0.78,0.781-2.047,0-2.828C70.321,50.536,67.678,49.44,64.866,49.44z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.029,46.667c1.535,0,2.784-1.249,2.784-2.785s-1.249-2.785-2.784-2.785c-1.536,0-2.785,1.249-2.785,2.785 S34.493,46.667,36.029,46.667z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.239,
    cy: 43.882,
    r: 2.785
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.971,46.667c1.536,0,2.785-1.249,2.785-2.785s-1.249-2.785-2.785-2.785c-1.535,0-2.784,1.249-2.784,2.785 S58.436,46.667,59.971,46.667z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69.761,
    cy: 43.882,
    r: 2.785
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMood);
export default __webpack_public_path__ + "static/media/mood.023087108c5ca67bf420cad6fa190858.svg";
export { ForwardRef as ReactComponent };